<template>
  <v-dialog width="600" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn icon color="purple" v-on="on"><v-icon>mdi-printer</v-icon></v-btn>
    </template>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Imposta Stampa
      </v-card-title>
      <v-card-text>
        <v-row class="">
          <v-col cols="10">
            <v-list-item>
              <v-list-item-avatar>
                <v-img :src="avatar_img"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ nome_prodotto[0] }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ nome_prodotto[1] }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row class="">
          <v-col cols="12">
            <v-autocomplete
              class="pl-4"
              v-model="lotto"
              placeholder="Lotto"
              outlined
              :items="lotti"
              item-text="codice"
              item-value="id"
              hide-details
            >
              <template v-slot:selection="data">
                <v-list-item-avatar>
                  <img :src="avatar_fornit(data.item.id_fornitore)" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.codice"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="nome_fornit(data.item.id_fornitore)"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar>
                  <img :src="avatar_fornit(data.item.id_fornitore)" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.codice"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="nome_fornit(data.item.id_fornitore)"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              class="pl-4"
              v-model="torba"
              placeholder="Torba"
              outlined
              :items="torbe"
              item-text="nome"
              item-value="id"
              hide-details
            >
              <template v-slot:selection="data">
                <v-list-item-avatar>
                  <img :src="avatar_fornit(data.item.id_fornitore)" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.nome"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="nome_fornit(data.item.id_fornitore)"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <template v-slot:item="data">
                <v-list-item-avatar>
                  <img :src="avatar_fornit(data.item.id_fornitore)" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-html="data.item.nome"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="nome_fornit(data.item.id_fornitore)"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ml-4">
            <v-checkbox label="Specifica Posizione" v-model="reg_posizione" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="reg_posizione">
            <v-select
            class="pl-4"
              prepend-inner-icon="mdi-greenhouse"
              outlined
              :items="zone_coltivazione"
              multiple
              chips
              v-model="id_zone"
              item-text="nome"
              item-value="id"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn outlined color="green" @click="invia_stampa()" :loading="loading"><v-icon class="mr-2">mdi-printer</v-icon> Stampa</v-btn>
        <v-btn text color="grey" @click="close()">chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    id_prodotto: String,
    id_fornitore: String,
  },
  data() {
    return {
      dialog: false,
      reg_posizione: false,
      lotto: null,
      torba: null,
      loading: false,
      print_ok: false,
      eg_posizione: false,
      id_zone: [],
    };
  },
  computed: {
    prodotto() {
      return this.$store.getters.get_prodotto_by_id(this.id_prodotto);
    },
    nome_prodotto() {
      return this.prodotto.nome.split(" in ");
    },
    avatar_img() {
      return process.env.VUE_APP_API_ROOT + "/avatar_img/" + this.id_prodotto;
    },
    zone_coltivazione() {
      return this.$store.getters.get_zone_coltivazione;
    },
    lotti() {
      let lotti_raw = this.$store.getters.get_lotti;
      return lotti_raw
        .filter((lotto) => lotto.id_fornitore == this.id_fornitore)
        .sort((a, b) => b.ts_documento - a.ts_documento);
    },
    torbe() {
      return this.$store.getters.get_torbe;
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    avatar_fornit(id) {
      return process.env.VUE_APP_API_ROOT + "/fornitore/" + id + "/avatar";
    },
    nome_fornit(id) {
      return this.$store.getters.get_fornitore_by_id(id).nome;
    },
    invia_stampa() {
      this.loading = true;
      this.$store
        .dispatch("imposta_stampa", {
          id_prodotto: this.prodotto.id,
          id_lotto: this.lotto,
          id_torba: this.torba,
          reg_posizione: this.reg_posizione,
          id_zone: this.id_zone,
        })
        .then(() => {
          this.loading = false;
          this.print_ok = true;
          setTimeout(() => {
            this.print_ok = false;
          }, 3000);
        });
    },
  },
};
</script>